<app-product-breadcrumb [title]="'Checkout'" [breadcrumb]="'Checkout'"></app-product-breadcrumb>

<!-- section start -->
<section class="p-0" *ngIf="errore && carricamentoDati">
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <div class="error-section">
                    <h1>404</h1>
                    <h2>page not found</h2>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- Section ends -->

<!-- thank-you + success visit section start -->
<section class="section-b-space" *ngIf="!errore">
    <div class="container">
        <div class="sv-wrap">
            <div class="sv-icon"><i class="fa fa-check-circle" aria-hidden="true"></i></div>
            <h3 class="title-brown text-center" *ngIf="visitDetails.Regalo !== true">{{
                "shoponline.PaginaVisitSuccess.Grazie" | translate }} {{
                "shoponline.PaginaVisitSuccess.perAverPrenotato" | translate }}</h3>
            <p class="text sv-intro"> {{ "shoponline.PaginaVisitSuccess.PuoiContattarciVia" | translate }} &nbsp;<b
                    class="gold-text">
                    &#115;&#097;&#108;&#101;&#115;&#064;&#099;&#097;&#115;&#101;&#105;&#102;&#105;&#099;&#105;&#111;&#045;&#115;&#111;&#114;&#097;&#103;&#110;&#097;&#046;&#105;&#116;
                </b><br> {{ "shoponline.PaginaCheckoutSuccess.PuoiChiamarci" | translate }}
                <a href="tel:0524 599073">
                    <span class="gold-text">{{ "info-caseificio.telefono" | translate }}</span>
                </a> {{ "shoponline.PaginaVisitSuccess.perQualsiasiEsigenza" | translate }}.
            </p>

            <div class="ornament pb-4"></div>

            <aside class="visit-ticket-stub">
                <span class="stub-eyebrow">{{ "shoponline.PaginaVisitSuccess.dettagli" | translate }}</span>
                <h3>{{ "La tua visita" | translate }}</h3>
                <dl class="stub-details">
                    <div>
                        <dt>{{ "shoponline.PaginaVisitSuccess.numPersone" | translate }}</dt>
                        <dd>{{visitDetails.Nperson}}</dd>
                    </div>
                    <div>
                        <dt>{{ "shoponline.PaginaVisitSuccess.numBambini" | translate }}</dt>
                        <dd>{{visitDetails.Nchild}}</dd>
                    </div>
                    <div *ngIf="visitDetails.NchildUnder6 && visitDetails.NchildUnder6 !==0">
                        <dt>{{ "shoponline.PaginaVisitSuccess.numBambiniSotto6" | translate }}</dt>
                        <dd>{{visitDetails.NchildUnder6}}</dd>
                    </div>
                    <div *ngIf="visitDetails.Regalo !== true">
                        <dt>{{ "shoponline.PaginaVisitSuccess.data" | translate }}</dt>
                        <dd>{{visitDetails.VisitDate | date: "dd-MM-yyyy"}}</dd>
                    </div>
                    <div *ngIf="visitDetails.Regalo !== true">
                        <dt>{{ "shoponline.PaginaVisitSuccess.ora" | translate }}</dt>
                        <dd>{{visitDetails.VisitTime}}</dd>
                    </div>
                    <div>
                        <dt>{{ "shoponline.PaginaVisitSuccess.lingua" | translate }}</dt>
                        <dd>{{visitDetails.Language}}</dd>
                    </div>
                    <div>
                        <dt>{{ "shoponline.PaginaVisitSuccess.degustazione" | translate }}</dt>
                        <dd>
                            <span
                                *ngIf="visitDetails.Tasting == true || visitDetails.Tasting2 == true || visitDetails.Tasting3 == true">
                                {{"Sì" | translate}}
                                <span *ngIf="visitDetails.Tasting2 == true"> {{"(con anolini)" | translate}}</span>
                                <span *ngIf="visitDetails.Tasting3 == true"> (con anolini e panino con
                                    culatello)</span>
                            </span>
                            <span
                                *ngIf="visitDetails.Tasting == false && visitDetails.Tasting2 == false && visitDetails.Tasting3 == false">
                                {{"No" | translate}}</span>
                        </dd>
                    </div>
                    <div>
                        <dt>{{ "shoponline.PaginaVisitSuccess.regalo" | translate }}</dt>
                        <dd *ngIf="visitDetails.Regalo == true">{{"Sì" | translate}}</dd>
                        <dd *ngIf="visitDetails.Regalo !== true">{{"No" | translate}}</dd>
                    </div>
                </dl>
                <div class="stub-perforation"></div>
                <div class="stub-total">
                    <span>{{ "shoponline.PaginaVisitSuccess.prezzo" | translate }}</span>
                    <strong>&euro;{{visitDetails.Total}}</strong>
                </div>
                <a [routerLink]="['/']" class="btn btn-solid visit-cta">{{ "home-link" | translate }}</a>
            </aside>
        </div>
    </div>
</section>
<!-- Section ends -->
